import React from 'react'
import type { MenuProps } from 'antd'
import { Menu } from 'antd'
import { useNavigate } from 'react-router-dom'
import style from './Sidebar.module.css'

import {
  DashboardOutlined,
  UsergroupAddOutlined,
  BranchesOutlined,
} from '@ant-design/icons'

import { RoutesPath } from '@/shared/types/RoutesPath'
import { useAppSelector } from '@/shared/types'
import { selectUserMe } from '@/entities/session/model/slice'
import { UserRoles } from '@/entities/user/model/types'

type MenuItem = Required<MenuProps>['items'][number]

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  visible?: boolean,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    visible,
  } as MenuItem
}

export const Sidebar = () => {
  const navigate = useNavigate()

  const me = useAppSelector(selectUserMe)
  const theme = 'dark'

  const handleMenuItemClick = (key: RoutesPath) => {
    navigate(key, { replace: true })
  }
  const items: MenuItem[] = [
    getItem(
      'Users',
      RoutesPath.USRES,
      <UsergroupAddOutlined />,
      [UserRoles.SUPER_ADMIN, UserRoles.OPERATIONS_MANAGER].includes(
        me?.role_key,
      ),
    ),
    getItem('Work Orders', RoutesPath.WORK_ORDER, <DashboardOutlined />, true),
    getItem(
      'Inventory',
      RoutesPath.INVENTORY,
      <BranchesOutlined />,
      [
        UserRoles.SUPER_ADMIN,
        UserRoles.WEREHOUSE_MANAGER,
        UserRoles.OPERATIONS_MANAGER,
      ].includes(me?.role_key),
    ),
  ]

  const path = items.find(item =>
    window.location.pathname.includes(item?.key),
  )?.key

  return (
    <Menu
      theme={theme}
      mode='inline'
      defaultSelectedKeys={[path]}
      defaultOpenKeys={[path]}
      items={items.filter(item => item.visible)}
      onClick={({ key }) => handleMenuItemClick(key)}
      className={style.sidebar}
    />
  )
}
